import TemplatesModel from '#model/TemplatesModel'
import { useApiClient } from '#context/ApiContext'
import { useNotifications } from '#context/NotificationContext'
import { useInstanceOf } from 'eilmer-mvvm/react'

export default class TemplatesViewModel {
  constructor(apiClient, notificationsProvider) {
    this.model = new TemplatesModel(apiClient)
    this.notifications = notificationsProvider
    this.entity = new TemplatesModel.Template()
    this.editing = false
    this.loadEntities()
  }

  async loadEntities() {
    try {
      this.entities = await this.model.getTemplates()
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  doEditEntity(entity) {
    this.entity = new TemplatesModel.Template(entity)
    this.editing = true
  }

  doCancelEdit() {
    this.editing = false
  }

  async doSaveEntity(entity) {
    try {
      if (entity.isNew()) {
        const result = await this.model.createTemplate(entity)
        this.editing = false
        this.loadEntities()
        return result
      } else {
        const result = await this.model.updateTemplate(entity)
        this.editing = false
        this.loadEntities()
        return result
      }
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  async doDeleteEntity(entity) {
    if (
      await this.notifications.confirm(
        "Are you sure you'd like to delete this template?"
      )
    ) {
      try {
        const result = await this.model.deleteTemplate(entity)
        this.loadEntities()
        return result
      } catch (err) {
        console.error(err)
        this.notifications.error(err.message)
      }
    }
  }

  get fields() {
    return [
      {
        key: 'template_id',
        label: 'ID',
        _style: { width: '6%' },
        _classes: 'bg-light text-dark',
      },
      { key: 'name', _style: { width: '25%' } },
      { key: 'description' },
      {
        key: 'actions',
        label: '',
        _style: { width: '90px' },
        filter: false,
      },
    ]
  }
}

TemplatesViewModel.useInstance = function () {
  return useInstanceOf(TemplatesViewModel, useApiClient(), useNotifications())
}
